import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=d6b90a74&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=d6b90a74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b90a74",
  null
  
)

export default component.exports